import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AppUpdateService } from './app-update.service';

@Component({
	selector: 'app-update-banner',
	standalone: true,
	imports: [MatButtonModule],
	templateUrl: './app-update-banner.component.html',
	styleUrls: ['./app-update-banner.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateBannerComponent implements OnInit {
	readonly appUpdate = inject(AppUpdateService);

	ngOnInit(): void {
		this.appUpdate.start();
	}
}
